import React, { Component } from 'react';
import moment from 'moment';

import { trans } from '../../../../../localization';
import { isEmptyObject } from '../../../../../utils/utils';

function OutOfStockItemView({ isOutOfStock }) {
  return (
    <div className="btn-group btn-toggle">
      {isOutOfStock && (
        <button
          className={`btn btn-xs ${isOutOfStock ? 'btn-danger' : 'btn-gray'}`}
        >
          {trans('mod_detail_over')}
        </button>
      )}
    </div>
  );
}

class OutOfStockItem extends Component {
  render() {
    const {
      isOutOfStock,
      handleOpenOutOfStockModal,
      currentOfStock,
      isHaveChangeOrder,
      outOfStockObj,
    } = this.props;
    if (!isHaveChangeOrder) {
      return <OutOfStockItemView isOutOfStock={isOutOfStock} />;
    }
    return (
      <React.Fragment>
        <div className="btn-group btn-toggle">
          <button
            className={`btn btn-xs ${
              !isOutOfStock ? 'btn-red' : 'btn-white'
            }`}
            onClick={() => handleOpenOutOfStockModal(outOfStockObj)}
          >
            {trans('mod_detail_still')}
          </button>
          <button
            className={`btn btn-xs ${
              isOutOfStock ? 'btn-danger' : 'btn-white'
            }`}
            onClick={() => handleOpenOutOfStockModal(outOfStockObj)}
          >
            {trans('mod_detail_over')}
          </button>
        </div>
        {isOutOfStock && !isEmptyObject(currentOfStock) && (
          <div>
            <span>
              <b>{moment(currentOfStock.from).format('HH:mm')}</b>{' '}
              {moment(currentOfStock.from).format('DD/MM')}
            </span>
            <br />
            <span>
              <b>{moment(currentOfStock.to).format('HH:mm')}</b>{' '}
              {moment(currentOfStock.to).format('DD/MM')}
            </span>
          </div>
        )}
      </React.Fragment>
    );
  }
}
export default OutOfStockItem;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/components/OutOfStockItem.jsx